import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from "rxjs/operators";
import { of } from "rxjs/observable/of";

import {ResourceRestService} from "@ispm/workflow/services/resource-rest.service";

@Injectable()
export class AberrationInfoService {
  public static baseUrl = '/aberration';

  constructor(
    private translate: TranslateService,
    private resourceRest: ResourceRestService
  ) {
  }

  public getAberrationInfo(aberration, testTableData, revisionId, currentModality) {
    if (!aberration.extra) {
      return this.resourceRest.get(AberrationInfoService.baseUrl + '/getAnnotations/', { aberration: aberration.id, revision: revisionId})
        .pipe(
          map(res => res.json()),
          map(res => {
          if (currentModality in testTableData.manualAnnotations) {
            testTableData.manualAnnotations[currentModality].forEach((ann) => {
              if (!res[ann.annType] || !res[ann.annType].annotations) {
                res[ann.annType] = { annotations: []};
              }

              res[ann.annType].annotations.push({
                name: ann.name,
                value: aberration[ann.name]
              });
            });
          }
          return this.buildAberrationExtraDataObj(res, testTableData);
          }),
          catchError(err => {
            console.error(`Error getting annotations for aberration ${aberration.id}: ${err.message}`);
            return of([]);
          }),
        );
    } else {
      return Observable.of(aberration.extra);
    }
  }

  public getAberrationInfoPromise(aberration, testTableData, revision, currentModality) {
    return this.getAberrationInfo(aberration, testTableData, revision, currentModality).toPromise();
  }

  private buildAberrationExtraDataObj(res, testTableData) {
    const aberrationExtraData = { };
    if (testTableData.annotationsCategories) {
      testTableData.annotationsCategories.forEach((category) => {
        if (res[category] && res[category].annotations.length > 0) {
          const translateCategory = this.translate.instant('annotation.' + category, category);
          aberrationExtraData[translateCategory] = res[category];
          aberrationExtraData[translateCategory].translatedCategory = translateCategory;
          aberrationExtraData[translateCategory].preTranslationCategory = category;
        }
      });
    } else {
      res.forEach((value, key) => {
        if (value.annotations.length > 0) {
          const translateCategory = this.translate.instant('annotation.' + key, key);
          aberrationExtraData[translateCategory] = value;
          aberrationExtraData[translateCategory].translatedCategory = translateCategory;
          aberrationExtraData[translateCategory].preTranslationCategory = key;
        }
      });
    }
    return aberrationExtraData;
  }
}
